import { render, staticRenderFns } from "./downloadIosApp.vue?vue&type=template&id=180b1d01&scoped=true&"
import script from "./downloadIosApp.vue?vue&type=script&lang=js&"
export * from "./downloadIosApp.vue?vue&type=script&lang=js&"
import style0 from "./downloadIosApp.vue?vue&type=style&index=0&id=180b1d01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b1d01",
  null
  
)

export default component.exports